export default __webpack_public_path__ + "static/media/icon-atlas.d2e10a65.png";